import { getTableVisibleColumns } from '../../../Table'

const MOCK_ITEMS_COUNT = 23

const MOCK_DATE_BASE = Date.UTC(2022, 5, 29, 17, 0)

const MOCK_DAY_MS = 24 * 60 * 60 * 1000

const MOCK_PARTICIPANTS = [
  {
    avatar: null,
    avatar_color: '#216ba5',
    email: 'riley@example.com',
    fullname: 'Riley Evans',
    id: 101,
  },
  {
    avatar: null,
    avatar_color: '#8b5cf6',
    email: 'uriah@example.com',
    fullname: 'Uriah Roberts',
    id: 102,
  },
  {
    avatar: null,
    avatar_color: '#f59e0b',
    email: 'alexander@example.com',
    fullname: 'Alexander Miller',
    id: 103,
  },
  {
    avatar: null,
    avatar_color: '#10b981',
    email: 'isabella@example.com',
    fullname: 'Isabella Scott',
    id: 104,
  },
  {
    avatar: null,
    avatar_color: '#0ea5e9',
    email: 'james@example.com',
    fullname: 'James Adams',
    id: 105,
  },
  {
    avatar: null,
    avatar_color: '#84cc16',
    email: 'charlotte@example.com',
    fullname: 'Charlotte Hughes',
    id: 106,
  },
  {
    avatar: null,
    avatar_color: '#ec4899',
    email: 'emily@example.com',
    fullname: 'Emily Martinez',
    id: 107,
  },
  {
    avatar: null,
    avatar_color: '#f97316',
    email: 'liam@example.com',
    fullname: 'Liam Ingram',
    id: 108,
  },
]

const MOCK_UPDATERS = [
  {
    avatar: null,
    avatar_color: '#6366f1',
    email: 'jackson@example.com',
    fullname: 'Jackson Lee',
    id: 201,
  },
  {
    avatar: null,
    avatar_color: '#14b8a6',
    email: 'mia@example.com',
    fullname: 'Mia Johnson',
    id: 202,
  },
  {
    avatar: null,
    avatar_color: '#06b6d4',
    email: 'ava@example.com',
    fullname: 'Ava Jones',
    id: 203,
  },
  {
    avatar: null,
    avatar_color: '#64748b',
    email: 'liam.t@example.com',
    fullname: 'Liam Thompson',
    id: 204,
  },
  {
    avatar: null,
    avatar_color: '#eab308',
    email: 'sophia@example.com',
    fullname: 'Sophia Wright',
    id: 205,
  },
  {
    avatar: null,
    avatar_color: '#22c55e',
    email: 'gabriel@example.com',
    fullname: 'Gabriel Clark',
    id: 206,
  },
]

const MOCK_SUBJECTS = [
  'Maintenance visit confirmation',
  'Lease renewal documents',
  'Invoice for the last quarter',
  'Heating system inspection report',
  'Update on your service request',
  'Annual utility statement',
  'Key handover appointment',
]

const MOCK_PREVIEWS = [
  'Donec fringilla ligula ac ipsum luctus, et dapibus erat ornare.',
  'Integer finibus. Sed id orci nec arcu dapibus mollis.',
  'Aenean ligula eget tortor sodales, ac lobortis enim.',
  'Praesent blandit laoreet nibh. Sed non odio euismod.',
  'Vestibulum ante ipsum primis in faucibus orci luctus et.',
]

export const EMAIL_ARCHIVE_MOCK_COLUMNS_CONFIG = {
  last_message_created: {
    index: 2,
    name: 'last_message_created',
    ordering_field: null,
    title: 'EmailTable.DateColumnTitleKey',
    visible: true,
    width: 200,
  },
  participants: {
    index: 0,
    name: 'participants',
    ordering_field: null,
    title: 'EmailTable.ParticipantsColumnTitleKey',
    visible: true,
    width: 240,
  },
  subject: {
    index: 1,
    name: 'subject',
    ordering_field: null,
    title: 'EmailTable.MessageColumnTitleKey',
    visible: true,
    width: 520,
  },
  updated: {
    index: 4,
    name: 'updated',
    ordering_field: null,
    title: 'Widget.UpdatedOnTitleKey',
    visible: true,
    width: 200,
  },
  updated_by: {
    index: 3,
    name: 'updated_by',
    ordering_field: null,
    title: 'EmailTable.UpdatedByColumnTitleKey',
    visible: true,
    width: 240,
  },
}

export const EMAIL_ARCHIVE_MOCK_VISIBLE_COLUMNS = getTableVisibleColumns(
  EMAIL_ARCHIVE_MOCK_COLUMNS_CONFIG
)

function buildMockItem(index) {
  const participant = MOCK_PARTICIPANTS[index % MOCK_PARTICIPANTS.length]
  const date = new Date(MOCK_DATE_BASE - index * MOCK_DAY_MS).toISOString()

  return {
    last_message: {
      outgoing: false,
      owner: participant,
      recipients: [participant],
      text_preview: MOCK_PREVIEWS[index % MOCK_PREVIEWS.length],
    },
    last_message_created: date,
    permissions: { can_view_original_email: index % 2 === 0 },
    subject: MOCK_SUBJECTS[index % MOCK_SUBJECTS.length],
    updated: date,
    updated_by: MOCK_UPDATERS[index % MOCK_UPDATERS.length],
    uuid: `mock-email-copy-${index}`,
  }
}

export const EMAIL_ARCHIVE_MOCK_ITEMS = Array.from(
  { length: MOCK_ITEMS_COUNT },
  (_, index) => buildMockItem(index)
)
